import { createSlice } from "@reduxjs/toolkit";

const initialBranch = {
  name: ""
};

const initialBranchesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  branch: initialBranch
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const branchSlice = createSlice({
  name: "branches",
  initialState: initialBranchesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBranches
    branchesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getBranch
    branchFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.branch = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanBranchesState
    branchesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.branch = initialBranch;
    }
  }
});